import accountApi from './client/accountApi'
import baseDataApi from './client/baseDataApi'
import shopApi from "./client/shopApi";
import publisherAccountApi from './publisher/publisherAccountApi'
import publisherShopApi from './publisher/publisherShopApi'

const apis = {
  accountApi,
  publisherAccountApi,
  baseDataApi,
  shopApi,
  publisherShopApi
}

export const apiFactory = {
  get: name => apis[name]
}
